import { Box } from "@mui/material";
import { useAtom } from "jotai";
import { useEffect, useRef, useState } from "react";
import { toastOptionsAtom } from "../../../atoms";
import { InvoicePaymentInitiatePayload } from "../../../types";
import Loading from "../../common/loading/Loading";
import { useCheckPaymentMutation } from "../../../api";

type Props = {
  payload: InvoicePaymentInitiatePayload | undefined;
  orgId: number;
};

export const CheckPayment = ({ payload, orgId }: Props) => {
  const hasMutated = useRef(false);
  const [paymentCallbackUrl, setPaymentCallbackUrl] = useState<string>();
  const [, setToastOptions] = useAtom(toastOptionsAtom);
  const [isIframeLoading, setIsIframeLoading] = useState(true);
  const checkPaymentMutation = useCheckPaymentMutation();

  useEffect(() => {
    if (payload && !hasMutated.current) {
      hasMutated.current = true;
      setTimeout(() => {
        checkPaymentMutation.mutate({
          orgId: orgId,
          accountId: payload.accountId,
          invoiceNumber: payload.invoiceNumber,
          amount: payload.invoiceAmount,
          bankName: payload.bankName || "",
          checkNumber: payload.checkNumber || "",
        });
      }, 100);
    }
  }, []);

  useEffect(() => {
    if (checkPaymentMutation.isSuccess) {
      const callBackUrl = checkPaymentMutation.data;
      setPaymentCallbackUrl(callBackUrl);
    }

    if (checkPaymentMutation.isError) {
      setToastOptions({
        open: true,
        message: "Something went wrong",
        severity: "error",
      });
    }
  }, [
    checkPaymentMutation.isSuccess,
    checkPaymentMutation.isError,
    checkPaymentMutation.isLoading,
    checkPaymentMutation.data,
    checkPaymentMutation.error,
  ]);

  return (
    <Box
      sx={{
        borderRadius: "10px",
        minHeight: "630px",
        py: "auto",
      }}
    >
      <iframe
        style={{
          height: "630px",
          width: "100%",
          border: "none",
        }}
        src={paymentCallbackUrl}
        onLoad={() => setIsIframeLoading(false)}
      ></iframe>
      {(checkPaymentMutation.isLoading || isIframeLoading) && (
        <Loading
          message=" "
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2,
            backgroundColor: "rgba(255, 255, 255, 0.6)",
          }}
        />
      )}
    </Box>
  );
};
